/**
 * 营运中心--》网络订单/开派车单
 */

export default {
  modify_web_order_field_label: ['98951'], // 202508151149482437534, 98951 新增或编辑网络订单修改字段label
  // 要求到货时间 改成非必填
  arrivedate_no_required: ['77335', '98951'], // 202509041026564375676
  no_reload_customer_after_add: ['92516'], // 202508291716116801057
  // 网络订单新增中转站
  show_middlesite: ['82635', '93052'], // 202509161519117676855
  // 开派车单底部checkboxbug fix
  get_dispatchorder_correct_checkbox: ['96570', '82635', '90100'], // 202510241848116134721
  // 派车单清单展示批量剔除
  dispatchorder_show_batch_del: ['88569'], // 202512040950431936396
  // 关联运单新增登录用户信息
  add_waybill_login_user: ['79027'],
};
